export { default } from "./diagram5.component";
